"use client";

import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  XAxis,
  YAxis,
  Legend,
} from "recharts";

import { ChartTooltip, ChartTooltipContent } from "../ui/chart";

//Styles
import * as S from "./styles";
import { useAuth } from "@/context/AuthContext";
import { formatCurrency as fmtCurrency } from "@/utils/formatCurrency";
interface RevenueBarChartProps {
  chartConfig: any;
  chartData: { hour: string; value: number }[];
  legendLabel?: string;
}

export const BarChartComponent: React.FC<RevenueBarChartProps> = ({
  chartConfig,
  chartData,
  legendLabel,
}) => {
  const { currency } = useAuth();
  const formatCurrency = (v: number) => fmtCurrency(v, currency || "R$");
  return (
    <S.BoxContainerChart
      config={chartConfig}
      className="mx-auto aspect-square min-h-[300px]"
    >
      <BarChart accessibilityLayer data={chartData}>
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="hour"
          tickLine={false}
          tickMargin={10}
          axisLine={false}
        />
        <YAxis tickFormatter={(v) => formatCurrency(Number(v))} width={60} />
        <ChartTooltip
          cursor={false}
          content={
            <ChartTooltipContent
              hideLabel
              formatter={(val) => formatCurrency(Number(val))}
            />
          }
        />
        <Legend verticalAlign="bottom" align="center" />
        <Bar
          dataKey="value"
          name={legendLabel || "Valor"}
          fill="var(--color-y)"
          radius={[6, 6, 0, 0]}
        >
          <LabelList
            position="top"
            offset={12}
            className="fill-foreground"
            fontSize={12}
            formatter={(v: number) => formatCurrency(Number(v))}
          />
        </Bar>
      </BarChart>
    </S.BoxContainerChart>
  );
};
